// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21u9T","fullView":"styles_fullView__zNhOb"};